import { render } from "./OrderStat.vue?vue&type=template&id=ff02f652&scoped=true"
import script from "./OrderStat.vue?vue&type=script&lang=js"
export * from "./OrderStat.vue?vue&type=script&lang=js"

import "./OrderStat.vue?vue&type=style&index=0&id=ff02f652&lang=less&scoped=true"

import exportComponent from "E:\\heguang\\hotel\\src\\manage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff02f652"]])

export default __exports__